import styled from 'styled-components';

// Components
import { Typography } from '../../../display/Typography';
import { MainButton } from '../../../inputs/buttons/MainButton';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 70vh;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 1rem 0;
`;

export const MaterialName = styled(Typography)`
  color: ${({ theme }) => theme.colors.black};
`;

export const HelpText = styled(Typography)`
  color: ${({ theme }) => theme.colors.greyDark};
`;

export const StickyFooter = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  padding: 1.5rem 0 0.5rem;
  background-color: ${({ theme }) => theme.colors.white};
  margin-top: auto;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    flex-direction: column-reverse;
    gap: 0.5rem;
  }
`;

export const CancelButton = styled(MainButton)`
  min-width: 10rem;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    width: 100%;
  }
`;

export const SubmitButton = styled(MainButton)`
  min-width: 10rem;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    width: 100%;
  }
`;
